import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Header from "../Header/Header";
import Sidebar from "../SideBar/Sidebar";
import UserTypeAPIs from "../../../MasonyFixingsAPIs/UserTypeAPIs/UserTypeAPIs";

function PrivateRoute() {
  const navigate = useNavigate();
  const [management, setManagement] = useState(false);

  const [sidebarOpen, setSidebarOpen] = useState(false); // Mobile overlay open
  const [collapsed, setCollapsed] = useState(
    () => localStorage.getItem("sidebarCollapsed") === "true"
  );

  // Persist collapsed state in localStorage
  useEffect(() => {
    localStorage.setItem("sidebarCollapsed", collapsed);
  }, [collapsed]);

  const getUserType = () => {
    UserTypeAPIs.GetUserType()
      .then((response) => {
        if (response.status === 200) setManagement(true);
      })
      .catch((err) => {
        console.log(err);
        if (err.response?.status === 401 && err.response.data.logout) {
          navigate("/login");
        }
      });
  };

  useEffect(() => {
    getUserType();
  }, []);

  return (
    <>
      {/* Header: pass collapsed setter */}
      <Header setSidebarOpen={setSidebarOpen} collapsed={collapsed} setCollapsed={setCollapsed} />

      {/* Mobile overlay */}
      {sidebarOpen && (
        <div className="app-overlay" onClick={() => setSidebarOpen(false)} />
      )}

      {/* Sidebar: pass collapsed state */}
      <Sidebar
        isOpen={sidebarOpen}
        setIsOpen={setSidebarOpen}
        collapsed={collapsed}
        management={management}
      />

      {/* Main content: adjusts margin based on sidebar collapse */}
      <div
        className={`app-main-content ${
          collapsed ? "collapsed" : ""
        }`}
      >
        <Outlet />
      </div>
    </>
  );
}

export default PrivateRoute;